<template>
  <select :id="id" class="select" v-model="selected" @change="onChange($event.target.value)">
    <option v-if="allYn == 'Y'" value=''>전체</option>
    <option v-for="code in codeList" v-bind:key="code.code" :value='code.code'>{{ code.name }}</option>
  </select>      
</template>

<script>
import Vue from 'vue'

export default {
  name: 'selectCodeList',
  props: {
    id: {
      type: String,
      default: "selectCode"
    },
    allYn: {
      type: String,
      default: "Y"
    },    
    codeType: "",
    value : ""
  },
  data () { 
    return {
      codeList: []
    }
  },    
  computed: {
    selected : {
      get() {
        return this.value
      },
      set() { }
    }
  },  
  mounted: function () {
    //this.$nextTick(function() {
      let params = {
        codeType : this.codeType
      }

      Vue.httpClient
      .get('/common/code/list', {params : params})
      .then((result) => {
        for (let i in result.data.result) {
          this.codeList.push({code: result.data.result[i].codeValue, name: result.data.result[i].codeName})
        }

        if (this.allYn != 'Y' && this.value == '') {
          this.$nextTick(function() {
            this.$emit('input', result.data.result[0].codeValue);
          });  
        }
      })
    //});
  },
  methods: {
    onChange(value) {
      this.$emit('input', value);
    }
  }  
}
</script>

<style scoped>
  div {
        display:inline;
  }
</style>


// WEBPACK FOOTER //
// src/components/SelectCodeList.vue